import * as yup from "yup";
import {
  getStringRequiredFieldMessage,
  validateGlobalPhoneNumber,
} from "@shared/utils/yup-extensions";
import {
  SubscriptionFlowConfigDto,
  SubscriptionFlowFieldDtoTypeEnum,
} from "@shared/apis/sidekick/generated";

export const getSubscriptionUserInfoFormSchema = (
  subscriptionFlowConfig: SubscriptionFlowConfigDto,
): yup.ObjectSchema<SubscriptionUserInfoSchema> => {
  const schema: Record<string, yup.AnySchema> = {};

  for (const field of subscriptionFlowConfig.stepUserInfo) {
    if (field.readOnly) continue;

    let fieldSchema: yup.StringSchema = yup.string().trim().label(field.label);

    if (field.type === SubscriptionFlowFieldDtoTypeEnum.PhoneNumber) {
      fieldSchema = fieldSchema.test(
        validateGlobalPhoneNumber({
          message: "Invalid phone number",
          optional: field.optional,
        }),
      );
    } else if (field.type === SubscriptionFlowFieldDtoTypeEnum.Email) {
      fieldSchema = fieldSchema.email("Invalid email address");
    }

    if (!field.optional) {
      fieldSchema = fieldSchema
        .min(1, getStringRequiredFieldMessage)
        .required();
    }

    schema[field.name] = fieldSchema;
  }

  return yup.object(
    schema,
  ) as unknown as yup.ObjectSchema<SubscriptionUserInfoSchema>;
};

export type SubscriptionUserInfoSchema = {
  name?: string;
  mlsId?: string;
  phoneNumber?: string;
  officeName?: string;
};
